/* eslint-disable max-lines */
/* eslint-disable radix */
/* eslint-disable no-underscore-dangle */
ACC.autocomplete = {
/* eslint-disable vars-on-top */
/* eslint-disable id-match */
/* eslint-disable max-len */
/* eslint-disable max-statements */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
  quantityCls: '.ph-quantity',
  orderDetailsId: '#ph-order-details-',
  disableBtnCls: 'ph-disable-button',
  shoppingListCartBtn: '.myshopping-list-button-',
  bindAll: function() {
    this.bindSearchAutocomplete();
  },
  disableEnableOosButton: function(parentlistId, listName) {
    var notinstockLen = parentlistId.find('.ph-orange-msg').length,
        arr = [],
        shoplist = '.myshopping-list',
        disable = 'ph-disable-but',
        codeExists = '';

    $(ACC.autocomplete.quantityCls).each(function() {
      arr.push($(this).val());
    });

    for (var ind = 0; ind < arr.length; ind = ind + 1) {
      if (arr[ind] > '0') {
        codeExists = true;

        break;
      } else {
        codeExists = false;
      }
    }

    if ((notinstockLen > 0) && (codeExists === false)) {
      $(shoplist + '-button-' + listName).addClass(disable + 'ton');
    } else {
      ACC.autocomplete.disableSAPEnableBtn(shoplist + '-button-' + listName, disable + 'ton');
    }
  },
  validateForNonZeroQuantity: function(parentlistId) {
    var shoppingListRow = parentlistId.find('.product-container .ph-myshopping-list-row'),
        qtyVal = '',
        isNonZeroQuantity = '';

    $(shoppingListRow).each(function() {
      qtyVal = $(this).find(ACC.autocomplete.quantityCls).val();

      if (parseInt(qtyVal) > 0) {
        isNonZeroQuantity = true;

        return false;
      }

      isNonZeroQuantity = false;

      return true;
    });

    return isNonZeroQuantity;
  },
  disableEnableInstcButton: function(parentlistId, listName) {
    var instockLen = parentlistId.find('.ph-green').length,
        lowstockLen = parentlistId.find('.ph-orange').length,
        isQuantityValid = '',
        disable = 'ph-disable-but',
        shoplist = '.myshopping-list';

    isQuantityValid = ACC.autocomplete.validateForNonZeroQuantity(parentlistId);

    if ((instockLen > 0 || lowstockLen > 0) && isQuantityValid) {
      ACC.autocomplete.disableSAPEnableBtn(shoplist + '-button-' + listName, disable + 'ton');
    } else {
      $(shoplist + '-button-' + listName).addClass(disable + 'ton');
    }
  },
  disableEnableListErrormsg: function(parentId) {
    var notinstockLen = parentId.find('.ph-not-avail-msg.ph-orange-msg').length,
        errmg = 'lognostkerrormsg';

    if (notinstockLen > 0) {
      parentId.find('.ph-' + errmg).removeClass('hidden');
    } else {
      parentId.find('.ph-' + errmg).addClass('hidden');
    }
  },
  disableSAPEnableBtn: function(parentId, addToCartBtn) {
    var orderBlockTxt = 'orderBlock';

    if ($('.ph-sap-' + orderBlockTxt).length === 0) {
      $(parentId).removeClass(addToCartBtn);
    } else {
      $(parentId).addClass(addToCartBtn);
    }
  },
  checkForItemLevelErrors: function(listNameWithoutSpace) {
    var $listItem = $('#ph-order-details-' + listNameWithoutSpace),
        isOutOfStockPrds = $listItem.find('.ph-lognostkerrormsg:visible').length,
        prodNotAvail = $listItem.find('.ph-isblocked-msg:visible').length,
        isLowStockPrds = $listItem.find('.ph-shplist-stkavail:visible').length,
        isMaxQtyPrds = $listItem.find('.ph-productMaxQty_popupMsgError:visible').length,
        isAnnualMaxQtyPrds = $listItem.find('.ph-annualMaxQtyMsg:visible').length;

    if (isOutOfStockPrds > 0 || isLowStockPrds > 0 || prodNotAvail > 0 || isMaxQtyPrds > 0 || isAnnualMaxQtyPrds > 0) {
      $(ACC.autocomplete.shoppingListCartBtn + listNameWithoutSpace).addClass(ACC.autocomplete.disableBtnCls);
    } else {
      ACC.autocomplete.disableSAPEnableBtn(ACC.autocomplete.shoppingListCartBtn + listNameWithoutSpace, ACC.autocomplete.disableBtnCls);
    }
  },
  disableEnablebutton: function(buttonId, buttonStatus) {
    var disableButtonClass = 'disable-button';

    if (buttonStatus === 1) {
      $(buttonId).removeClass('ph-' + disableButtonClass);
    } else {
      $(buttonId).addClass('ph-' + disableButtonClass);
    }
  },
  disableEnableCheckbox: function(rowId, checkboxStatus) {
    var orderDet = 'order-details-',
        qtygetlistnameId = $('#row' + rowId).find(ACC.autocomplete.quantityCls).attr('id'),
        gtlistarr = qtygetlistnameId.split('-'),
        getlistnameId = gtlistarr[0],
        parntId = '#ph-' + orderDet + getlistnameId,
        checkboxelm = 'checkbox';

    if (checkboxStatus === 1) {
      $(parntId + ' #row' + rowId).find('.ph-' + checkboxelm).prop('checked', true).attr('disabled', false);
    } else {
      $(parntId + ' #row' + rowId).find('.ph-' + checkboxelm).attr('disabled', true).prop('checked', false);
    }
  },
  disableEnablepopup: function(popId, popStatus) {
    if (popStatus === 0) {
      popId.removeClass('ph-hidepopup');
    } else {
      popId.addClass('ph-hidepopup');
    }
  },
  disableEnableErrormsg: function(disabledLength, errorText, parntId) {
    var notinstockLen = $(parntId).find('.ph-not-avail-msg.ph-orange-msg').length;

    if (disabledLength > 0 || notinstockLen > 0) {
      errorText.removeClass('hidden');
    } else {
      errorText.addClass('hidden');
    }
  },
  quoteAjaxCall: function(quoteName, customerComments, requestedDeliveryDate, entries) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/quote/createQuote',
      data: {
        quoteName: quoteName,
        customerComments: customerComments,
        requestedDeliveryDate: requestedDeliveryDate,
        entries: entries.toString()
      },
      type: 'POST',
      datatype: 'json',
      success: function(data) {
      /* eslint-disable no-negated-condition */
        if (data.indexOf(ACC.neworder.sessionTimeoutIdentifier) !== -1) {
          window.location.reload();
        } else {
          $('#ph-quote__parent .ph-overlay').addClass('ph-d-none');
          $('.ph-quote-sendReq-parent .ph-interstitial-loader').addClass('hidden');
          $('#ph-updateQuoteDetailsForm').css('pointer-events', 'auto');
          $.colorbox({
            maxWidth: '520px',
            width: '100%',
            height: 'auto',
            closeButton: false,
            html: $('.ph-quote-thank-pop').html(),
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
              location.reload();
            }
          });
        }
      }
    });
    /* eslint-enable no-negated-condition */
  },
  // eslint-disable-next-line complexity
  checkAndEnableOrDisableAddtoCartBtn: function(shoppingListMainDiv) {
    var backorderToggle = $('#ph-backorderfeaturetoggle').val();

    if (shoppingListMainDiv.find('.ph-free-marketing-max-qty-shoppinglist-popup.hidden').length === shoppingListMainDiv.find('.ph-free-marketing-max-qty-shoppinglist-popup').length &&
      shoppingListMainDiv.find('.ph-productMaxQty_popupMsgError.hidden').length === shoppingListMainDiv.find('.ph-productMaxQty_popupMsgError').length &&
      shoppingListMainDiv.find('.ph-not-avail-msg-30-future-instock.hidden').length === shoppingListMainDiv.find('.ph-not-avail-msg-30-future-instock').length &&
      shoppingListMainDiv.find('.ph-not-avail-msg-30-future-lowstock.hidden').length === shoppingListMainDiv.find('.ph-not-avail-msg-30-future-lowstock').length &&
      shoppingListMainDiv.find('.ph-not-avail-msg-50-nostock.hidden').length === shoppingListMainDiv.find('.ph-not-avail-msg-50-nostock').length &&
      (shoppingListMainDiv.find('.ph-dchain-shoppinglist-error').length === 0) &&
      !(backorderToggle === 'true' && shoppingListMainDiv.find('.ph-shplist-stkavail.ph-hidepopup').length !== shoppingListMainDiv.find('.ph-shplist-stkavail').length) &&
      !(backorderToggle === 'true' && shoppingListMainDiv.find('.ph-not-avail-msg.hidden').length !== shoppingListMainDiv.find('.ph-not-avail-msg').length)) {
      shoppingListMainDiv.find('.myshopping-list-viewfulllist').removeClass('ph-disable-button');
    } else {
      shoppingListMainDiv.find('.myshopping-list-viewfulllist').addClass('ph-disable-button');
    }
  },
  // eslint-disable-next-line max-params, complexity
  checkAndDisplayAllMaxQtyPopup: function(result, maxQtyResult, productCode, parentdiv, backorderEnabled, maxQtyToggleEnabled, inputqty) {
    var qtygetlistnameId = $(parentdiv + ' #row' + productCode).find(ACC.autocomplete.quantityCls).attr('id'),
        gtlistarr = qtygetlistnameId.split('-'),
        getlistnameId = gtlistarr[0],
        parntId = ACC.autocomplete.orderDetailsId + getlistnameId,
        /* eslint-disable no-negated-condition, no-ternary */
        maxQty = maxQtyResult.productMaxQtyDatas !== null ? maxQtyResult.productMaxQtyDatas[0].maxQtyToOrder : -1,
        totalOrdered = maxQtyResult.productMaxQtyDatas !== null ? maxQtyResult.productMaxQtyDatas[0].totalOrdered : -1,
        isFreeMarkettingProduct = maxQtyResult.productMaxQtyDatas !== null ? maxQtyResult.productMaxQtyDatas[0].isFreeMarketingMaterial : false,
        maxMarketingMatQtyToOrder = maxQtyResult.productMaxQtyDatas !== null ? parseInt(maxQtyResult.productMaxQtyDatas[0].maxMarketingMatQtyToOrder, 10) : -1,
        /* eslint-enable no-negated-condition, no-ternary */
        popcheckId = $(parntId + ' #row' + productCode).find('.ph-shplist-stkavail'),
        lowStockQty = parseInt(result.atpData.lowStockQty),
        currentPositionId = $('#row' + productCode).closest('[id^="myshoppinglist-name"]').attr('id'),
        currentPosition = currentPositionId.split('')[currentPositionId.split('').length - 1],
        maxQtyText = '',
        dchainProdToggle = $('.ph-dchain-product-toggle').val(),
        dChainValue = result.dchainValue,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(result),
        // eslint-disable-next-line no-negated-condition, no-ternary
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line  compat/compat, no-negated-condition, no-ternary
        dChainFirstEntryQty = dChainFirstEntry !== null ? Object.values(dChainFirstEntry)[0] : '',
        $prodRow = $(parentdiv + ' #row' + productCode);

    var maxQtyReqParams = {
      nobackorderprod: backorderEnabled,
      maxQtyEnabled: maxQtyToggleEnabled,
      enteredQty: inputqty,
      lowStockQty: lowStockQty,
      maxQty: maxQty,
      totalOrdered: totalOrdered,
      isFreeMarketingProduct: isFreeMarkettingProduct,
      freeMarketingMaxQty: maxMarketingMatQtyToOrder,
      dChainProductToggle: dchainProdToggle,
      dChainProductValue: dChainValue,
      dChainProductFirstEntryDate: dChainFirstEntryDate,
      dChainProductFirstEntryQty: dChainFirstEntryQty
    };

    if (maxQtyResult.productMaxQtyDatas !== null && maxQtyResult.productMaxQtyDatas[0].showError === true) {
      $prodRow.find('.ph-annualMaxQtyMsg').html($('#ph-annualMaxQtyMsg').val());
      $prodRow.find('.ph-annualMaxQtyMsg').removeClass('ph-hidepopup');
      $prodRow.find('.ph-productMaxQty_popupMsgError').addClass('ph-hidepopup');
      $('#ph-shopbut-' + currentPosition).addClass('ph-disable-button');
    }

    $prodRow.find('.ph-productMaxQty_popupMsgError').addClass('hidden');
    $prodRow.find('.ph-free-marketing-max-qty-shoppinglist-popup').addClass('hidden');
    $prodRow.find('.ph-dchain-max-qty-shoppinglist-popup').addClass('hidden');
    ACC.autocomplete.disableEnablepopup(popcheckId, 1);

    if ($('.ph-annualMaxQtyMsg:visible').length === 0 && $('.ph-shplist-stkavail:visible').length === 0 && $('.ph-productMaxQty_popupMsgError:visible').length === 0 && $('.ph-sap-orderBlock').length === 0) {
      $('#ph-shopbut-' + currentPosition).removeClass('ph-disable-button');
    }

    // Commenting maxQtyText = ACC.common.getLowestMaxQtyValue(backorderEnabled === 'true', maxQtyToggleEnabled, inputqty, lowStockQty, maxQty, totalOrdered, isFreeMarkettingProduct, maxMarketingMatQtyToOrder);

    maxQtyText = ACC.common.checkAllMaxQtyValidation(maxQtyReqParams);

    if (maxQtyText === 'lowStock') {
      ACC.autocomplete.disableEnablepopup(popcheckId, 0);
      $('#ph-shopbut-' + currentPosition).addClass('ph-disable-button');
    } else if (maxQtyText === 'maxQty') {
      $prodRow.find('.ph-productMaxQty_popupMsgError').html($('#ph-maxQtyMsg').val());
      $prodRow.find('.ph-productMaxQty_popupMsgError').html($('#row' + productCode).find('.ph-productMaxQty_popupMsgError').html().replace('{0}', maxQty - totalOrdered));
      $prodRow.find('.ph-productMaxQty_popupMsgError').removeClass('hidden');
      $('#ph-shopbut-' + currentPosition).addClass('ph-disable-button');
    } else if (maxQtyText === 'freeMarketingMaxQty') {
      $prodRow.find('.ph-free-marketing-max-qty-shoppinglist-popup').find('.ph-free-max-qty-value').text(maxMarketingMatQtyToOrder);
      $prodRow.find('.ph-free-marketing-max-qty-shoppinglist-popup').removeClass('hidden');
      $('#ph-shopbut-' + currentPosition).addClass('ph-disable-button');
    } else if (maxQtyText === 'dChain50' || maxQtyText === 'dChain30') {
      $prodRow.find('.ph-dchain-max-qty-shoppinglist-popup').find('.ph-dchain-max-qty-value').text(dChainFirstEntryQty);
      $prodRow.find('.ph-dchain-max-qty-shoppinglist-popup').removeClass('hidden');
      $('#ph-shopbut-' + currentPosition).addClass('ph-disable-button');
    }

    ACC.autocomplete.checkAndEnableOrDisableAddtoCartBtn($prodRow.closest('.ph-shoppinglistmain'));
  },
  // eslint-disable-next-line max-params
  checkInputValue: function(productCode, backorderEnabled, inputqty, parentdiv, maxQtyToggleEnabled) {
    PHI.common.getMaxQuantity(productCode, function(maxQtyResult) {
      PHI.common.getAtpData(productCode, function(result) {
        ACC.autocomplete.checkAndDisplayAllMaxQtyPopup(result, maxQtyResult, productCode, parentdiv, backorderEnabled, maxQtyToggleEnabled, inputqty);
      });
    });
  },
  backorderAvailQtyCheck: function(inputqty, maxqty, productCode, parentdiv) {
    var qtygetlistnameId = $(parentdiv + ' #row' + productCode).find(ACC.autocomplete.quantityCls).attr('id'),
        gtlistarr = qtygetlistnameId.split('-'),
        getlistnameId = gtlistarr[0],
        parntId = ACC.autocomplete.orderDetailsId + getlistnameId,
        errorText = $(parntId).find('.ph-lognostkerrormsg'),
        disabledLength = '',
        popContent = $('#ph-backordermaxcountText').val(),
        popreplace = $(parntId + ' #row' + productCode).find('.ph-shplist-stkavail .ph-backordermaxcount'),
        disablebtnn = 'ph-disable-button',
        popcheckId = $(parntId + ' #row' + productCode).find('.ph-shplist-stkavail');

    popreplace.text(popContent.replace(' 0 ', ' ' + maxqty + ' '));

    if (parseInt(maxqty, 10) > 0 && parseInt(inputqty, 10) > parseInt(maxqty, 10)) {
      ACC.autocomplete.disableEnablepopup(popcheckId, 0);
      $(ACC.autocomplete.shoppingListCartBtn + getlistnameId).addClass(disablebtnn);
    } else {
      ACC.autocomplete.disableEnablepopup(popcheckId, 1);
    }

    ACC.autocomplete.disableEnableErrormsg(disabledLength, errorText, parntId);
  },
  bindSearchAutocomplete: function() { // NOSONAR
    var $search = $('.product-code');
    /* eslint-disable consistent-this */
    var self = this;
    /* eslint-enable consistent-this */
    var option = $search.data('options');
    var cache = {};

    // eslint-disable-next-line require-jsdoc
    function addProductToExistingList(current, event, uid) {
      var type = current.attr('order-type'),
          shopList = '.shoppinglist',
          productCode = '',
          listname = '',
          arr = [],
          productcountStr = 'productcount';

      if (type === 'shoppingList') {
        current.parents(shopList).find('input').val(uid.item.code);
        uid.item.value = uid.item.code;

        productCode = uid.item.value;
        listname = current.parent().parent('.ph-search').siblings('.order').find('.productcount').attr('data-listname');

        $(ACC.autocomplete.orderDetailsId + listname).find('.productcode').each(function() {
          arr.push($(this).val());
        });


        if (typeof listname === 'undefined') {
          var originalString = current.attr('id');
          var res = originalString.split('product_code-');

          listname = res[1];
        }

        var $codeExists = false;

        for (var ind = 0; ind < arr.length; ind = ind + 1) {
          if (arr[ind] === productCode) {
            $codeExists = true;
          }
        }


        if ($codeExists) {
          var $existingProduct = $('.ph-shoppinglisterror').val();

          /* eslint-disable no-alert */
          alert($existingProduct);
          /* eslint-enable no-alert */
          setTimeout(function() {
            var listNameWithoutSpace1 = listname.replace(/\s+/g, '');

            $('#product_code-' + listNameWithoutSpace1).val('');
          }, 50);
        } else {
          $.ajax({
            url: ACC.config.encodedContextPath + '/shoppinglist/addProductAsync',
            data: {
              productCode: productCode,
              quantity: 1,
              wishListCode: listname
            },
            type: 'POST',
            datatype: 'json',
            success: function(result) {
              var obj = $.parseJSON(JSON.stringify(result));

              $('.ph-response').html(obj.addProductToShoppingList);

              var productName = $('.ph-productname').html();
              var productDisplayName = $('.ph-productdisplayname').html();
              var ctv = $('.ph-productctv').html();
              var ctvCode = ctv.replace('/', '_');
              var isoCode = $('.ph-isocode').val();
              var productEan = $('.ph-productean').html();
              var productUrl = $('.ph-producturl').html();
              var productdetails = {
                ctv: ctv,
                productUrl: productUrl,
                isoCode: isoCode,
                ctvCode: ctvCode,
                isZoomDelivered: $('.ph-response').find('.ph-isZoomDelivered').html(),
                isFreeMarketingProduct: $('.ph-response').find('.ph-isFreeMarketingdProduct').html()
              };

              self.addProductToList(productCode, listname, obj, productName, productdetails, productEan, productDisplayName);
              $('.myshopping-list-viewfulllist').removeAttr('disabled');
              ACC.quotation.checkForBlockedProducts(productCode);

              var listNameWithoutSpace1 = listname.replace(/\s+/g, '');

              $('#product_code-' + listNameWithoutSpace1).val('');
              current.parents('.myshoppinglist-name').find('.fav_list_qty').html($('.ph-' + productcountStr).html());

              var productCount1 = $('.ph-' + productcountStr).html();

              if (productCount1 === 0) {
                $(ACC.autocomplete.shoppingListCartBtn + listNameWithoutSpace1).addClass(ACC.autocomplete.disableBtnCls);
              } else {
                ACC.autocomplete.disableSAPEnableBtn(ACC.autocomplete.shoppingListCartBtn + listNameWithoutSpace1, ACC.autocomplete.disableBtnCls);
              }
            },
            error: function() {
              $('.ph-response').html('');
            }
          });
        }
      } else {
        current.val(uid.item.code).blur();
        uid.item.value = uid.item.code;
      }
    }

    if (option) {
      $search.autocomplete({
        /* eslint-disable consistent-return */
        minLength: option.minCharactersBeforeRequest,
        delay: option.waitTimeBeforeRequest,
        appendTo: '.shoppinglist',
        source: function(request, response) {
          var term = request.term.toLowerCase();

          if (term in cache) {
            return response(cache[term]);
          }

          $.getJSON(option.autocompleteUrl, {
            term: request.term
          })
            .done(function(data) {
              var autoSearchData = [];

              if (data.products !== null) {
                $.each(data.products, function(inx, obj) {
                  autoSearchData.push({
                    value: obj.code + '-' + obj.name,
                    code: obj.code,
                    displayName: obj.displayName,
                    ctv: obj.ctv,
                    imageURL: obj.imageURL,
                    sapEan: obj.sapEan,
                    type: 'productResult'
                  });
                });
              }

              cache[term] = autoSearchData;


              return response(autoSearchData);
            }).fail(function() {
              return false;
            });
        },
        focus: function() {
          return false;
        },
        select: function(event, uind) {
          addProductToExistingList($(this), event, uind);
        }
      });
      $search.each(function() {
        var $proj = $(this),
            appenSearch = '',
            listid = $(this).attr('id'),
            countid = $('#' + listid).attr('data-autolistinput');

        if ($('#ph-quicklist').length > 0 && parseInt(countid) > 2) {
          appenSearch = $('#ph-quicklist .ui-autocomplete:first').detach();
        } else {
          appenSearch = $('#ui-id-' + countid).detach();
        }

        if ($('#ph-autosearchlist-' + countid).length > 0) {
          $('#ph-autosearchlist-' + countid).append(appenSearch);
          $('#ui-id-' + countid).attr('data-indcount', countid);
        }

        $proj.autocomplete('instance')._renderItem = function(usrl, item) {
          if (item.type === 'productResult') {
            var renderHtml = '';

            /* eslint-enable consistent-return */

            renderHtml = self.renderNewQuickOrderTemplate(item, this.term);

            return $('<li class=\'product\'>').data('item.autocomplete', item).append(renderHtml).appendTo(usrl);
          }

          return true;
        };
      });
    }
  },
  renderOldTemplate: function(productItem, option) {
    var templateHtml = '<a class=\'product clearfix ph-autocomp-list\'>',
        firstVal = productItem.value.split(/-(.+)/)[0],
        secVal = productItem.value.split(/-(.+)/)[1];

    if (option.displayProductImages && productItem.image !== null) {
      templateHtml = templateHtml + '<span class=\'desc clearfix\'>';
    }

    templateHtml = templateHtml + ('<span class=\'title ph-code-value\' >' + firstVal +
                      '</span><br/>' +
                      '<span class=\'title ph-desc-value\'  >' + secVal +
                      '</span>' +
                      '</span>' +
                      '</a>');

    return templateHtml;
  },
  renderNewQuickOrderTemplate: function(productItem, term) {
    var displayName = '',
        suggestedCode = '',
        sapEanElement = '',
        suggestedEan = '',
        templateHtml = '';

    displayName = productItem.ctv + ' ' + productItem.displayName;
    displayName = String(displayName).replace(new RegExp(term, 'gi'), '<b>$&</b>');
    suggestedCode = String(productItem.code).replace(new RegExp(term, 'gi'), '<b>$&</b>');
    suggestedEan = String(productItem.sapEan).replace(new RegExp(term, 'gi'), '<b>$&</b>');

    if (productItem.sapEan.length !== 0) {
      sapEanElement = '<span class="ph-search-ctv">EAN</span>' +
      '<span class="ph-value-ctv">: ' + suggestedEan + '</span>';
    }

    templateHtml = templateHtml + (
      '<a class=\'clearfix\'>' +
      '<div class=\'ph-search-img\'><img src=\'' + productItem.imageURL + '?wid=90&hei=90&$jpgsmall$ \'></div></a>' +
      '<div class=\'ph-right-cont\'>' +
      '<div class="ph-prodfirstdesc" style="-webkit-box-orient: vertical;">' +
      '<span class="ph-class-desc">' + displayName + '</span>' +
      '</div>' +
      '<div class="ph-ctv-details"><span class="ph-search-NC">12NC</span><span class="ph-value-NC">: ' + suggestedCode + '</span></br>' +
      sapEanElement +
      '</div></div>');

    return templateHtml;
  },
  /* eslint-disable max-params */
  addProductToList: function(productCode, listname, data, productName, productdetails, productEan, productDisplayName) {
    /* eslint-disable no-useless-concat */
    var listSku = $('.ph-12nc_list').val(),
        listCtv = $('.ph-ctv').val(),
        blockedProductError = $('.ph-blockedproduct__error').val(),
        prodCountH = '-productcount',
        listPosition = $('.ph' + prodCountH).html(),
        listNameWithoutSpace = listname.replace(/\s+/g, ''),
        prefProductCode = productCode,
        prdtId = $('.ph-preferredProductId').val(),
        emptytxt = $('.ph-notAvailTxt').val(),
        shoppingListImg = $('.ph-shoppinglistimg').val(),
        annualMaxQtyMsgtxt = $('#ph-annualMaxQtyMsg').val(),
        currentMaxVal = 999999,
        readonlyAttr = '',
        freeMarketingMaxQtyMsg = $('#ph-freeMarketingMaxQtyMsg').val(),
        dChainMaxQtyMsg = $('#ph-dchainMaxQtyMsg').val(),
        dchain30FutureInStock = $('#ph-dchain30FutureInStock').val(),
        dchain30FutureLowStock = $('#ph-dchain30FutureLowStock').val(),
        dchain50NoStock = $('#ph-dchain50NoStock').val(),
        shoplistParent = '';

    if (prdtId === 'PRODUCT_EAN') {
      prefProductCode = productEan;
    }

    if (productdetails.isZoomDelivered && productdetails.isZoomDelivered === 'true') {
      currentMaxVal = 1;
      readonlyAttr = 'readonly';
    }

    if (prefProductCode.length === 0) {
      prefProductCode = emptytxt;
    }

    var addProduct = String(String(String('<div class="ph-myshopping-list-row" id="row' + productCode +
                '" data-ctn="' + productdetails.ctv + '" data-list-name="shopping-list"' +
                '" data-list-position="' + listPosition + '" data-track-productcard-visibility">' +
                '<input type="hidden" class="ph-mainProductcode" value="' + productCode + '">' +
                '<input type="hidden" class="ph-is-free-marketing-product" value="' + productdetails.isFreeMarketingProduct + '">' +
                '<div class="myshopping-list-checkbox hidden">' +
                '<input type="checkbox" checked class="ph-checkbox checkbox-' + listNameWithoutSpace +
                '" list-name="' + listNameWithoutSpace + '" value="' + productCode + '"></div>' +
                '<div class="myshopping-list-img">' +
                '<img src="https://images.philips.com/is/image/PhilipsConsumer/' + productdetails.ctvCode) + '-IMS-') + productdetails.isoCode) + shoppingListImg + '">' +
                '</div>' +
                '<div class="ph-myshopping-list-product">' +
                '<div class="myshopping-list-product-name"><a href="' + ACC.config.encodedContextPath + productdetails.productUrl +
                '">' + productDisplayName + '</a></div>' +
                '<div class="myshopping-list-ctn"><span class="ph-prvalue">' + listSku + '</span>: <span class="ph-shoppinglistcode">' + prefProductCode + '</span></div>' +
                '<div class="myshopping-list-ctn ph-list-errcontainer"><span class="ph-carteanlabel">' + listCtv + '</span>: <span class="ph-carteanvalue">' + productdetails.ctv +
                '</span><div class="ph-isblocked-msg-' + productCode + ' ' + 'ph-orange-msg ph-msg-wrapper ' + ' ' + 'ph-p-1 hidden"> ' + blockedProductError +
                '</div><div class="ph-shplist-stkavail ph-error-red ph-hidepopup"><div class="ph-backordermaxcount" ></div></div>' +
                '<div class="ph-error-red ph-annualMaxQtyMsg ph-hidepopup">' +
                annualMaxQtyMsgtxt +
                '</div>' +
                '<div class="ph-not-avail-msg ph-msg-wrapper hidden"></div>' +
                '<div class="ph-not-avail-msg-30-future-instock ph-orange-msg ph-msg-wrapper hidden">' + dchain30FutureInStock + '</div>' +
                '<div class="ph-not-avail-msg-30-future-lowstock ph-orange-msg ph-msg-wrapper hidden">' + dchain30FutureLowStock + '</div>' +
                '<div class="ph-not-avail-msg-50-nostock ph-orange-msg ph-msg-wrapper hidden">' + dchain50NoStock + '</div>' +
                '</div>' +
                '<input type="hidden" name="ctv" class="ph-ctv' + productCode + '"data-ctv="' + productdetails.ctv + '" value="">' +

                '</div>' +
                '<div class="quantity ph-listquantity">' +
                '<input type="button" value="+" class="ph-list_qtyplus ph-list_plusminus" field="' + listNameWithoutSpace + '-' + productCode + '">' +
                '<div class="ph-popup ph-productQtytool ph-productMaxQty_popupMsgError ph-shoppingList_popup classJustForTheTest hidden"></div>' +
                '<div class="ph-popup ph-free-marketing-max-qty-shoppinglist-popup hidden">' + freeMarketingMaxQtyMsg + '</div>' +
                '<div class="ph-popup ph-dchain-max-qty-shoppinglist-popup hidden">' + dChainMaxQtyMsg + '</div>' +
                '<input type="text" ' + readonlyAttr + ' class="ph-quantity ph-qty-' + productCode + '" data-qtylistname="' + listname +
                '" value="1" max="' + currentMaxVal + '" min="0" name="' + productCode + '" id="' + listNameWithoutSpace + '-' + productCode + '">' +
                '<input type="button" value="-" class=" ph-list_qtyminus ph-list_plusminus" field="' + listNameWithoutSpace + '-' + productCode + '"></div>' +

                '<input type="hidden" name="productCode" class="productcode" value="' + productCode + '">' +
                '<input type="hidden" name="initialQuantity" class="initialquantity" value="">' +
                '<div class="myshopping-list-remove">' +
                '</div>' +
                '<div class="myshopping-list-remove hidden">' +
                '<a class="ph-remove" href="javascript:void(0);" data-productcode="' +
                 productCode + '" data-listName="' + listNameWithoutSpace + '" data-cleardivid="#row' + productCode + '">x</a>' +
                '</div>' +
                '</div> ';


    /* eslint-enable no-useless-concat */
    $('.product-container').append(addProduct);

    var productCount = $('.ph-productcount').html();

    $('#ph-listProductCount' + listNameWithoutSpace).val(productCount);
    shoplistParent = $('#ph-listProductCount' + listNameWithoutSpace).closest('.myshoppinglist-name').attr('id');

    PHI.common.getAtpData(productCode, function(result) {
      PHI.shoppinglistpopup.loadProductAtpData(result, listNameWithoutSpace, shoplistParent, '#ph-order-details-', '.ph-quantity');
    });
  },
  roundqty: function(inputval, packunit) {
    return Math.ceil(inputval / packunit) * packunit;
  },
  addProductToListQuote: function(productCode, productDisplayName, ctv, productUrl, imgUrl, productName, dataArr) {
    /* eslint-disable no-useless-concat */
    var count = $('.ph-quote__parent .ph-myshopping-list-row').length,
        newCount = count + 1,
        sapEanElement = '';

    if (dataArr[0] !== null) {
      sapEanElement = '<span class="ph-carteanlabel">EAN</span>: <span class="ph-carteanvalue">' + dataArr[0] +
      '</span>';
    }

    var addProduct = '<div class="ph-myshopping-list-row ph-quoteRow' + productCode +
    '" id="row' + productCode + '-' + newCount + '" data-ctn="' + ctv +
    '" data-code="' + productCode +
    '" data-list-name="shopping-list" data-list-position="' + newCount +
    '" data-track-productcard-visibility=""><div class="myshopping-list-img">' +
    '<img class="ph-freqorderedproduct__image ph-hhsyoumaylikeimage" src="' + imgUrl +
    '?wid=100&amp;hei=100&amp;$jpgsmall$"></div>' +
    '<div class="quantity ph-listquantity ph-float-left ph-ml-2 ph-mr-3 ph-quote-mobView">' +
    '<input type="button" value="+" class="ph-quote_qtyplus ph-list_plusminus " field="' +
    newCount + '-mob' + productCode + '" data-listname="aa"' + ' data-min=' + dataArr[1] + '><input type="text" id="' + newCount +
    '-mob' + productCode + '" class="ph-quantity ph-quantityMob ph-return-qtybox-quote" maxlength="10" name="' + productCode +
    '" max="999999" min=' + dataArr[1] + 'data-qtylistname="aa" data-min=' + dataArr[1] + ' value=' + dataArr[1] + ' onkeypress="return isNumberKey(event)">' +
    '<input type="button" value="-" class=" ph-quote_qtyminus ph-list_plusminus ph-disable-button" field="' + newCount +
    '-mob' + productCode + '" data-listname="aa"' + ' data-min=' + dataArr[1] + '></div>' +
    '<div class="ph-float-left ph-quote-mobView ph-mt-2 ph-ml-1">' +
    '<div class="ph-img-trashbin ph-quickorder ph-quote-del" data-attr="' + productCode + '-' +
    newCount + '"></div></div>' + '<div class="ph-myshopping-list-product">' +
    '<div class="myshopping-list-product-name ph-prodfirstdesc" style="-webkit-box-orient: vertical;"><a href="' +
    ACC.config.encodedContextPath + productUrl + '" title="' + productName + '">' + ctv +
    '&nbsp;' + productDisplayName + '</a></div><div class="myshopping-list-ctn">' +
    '<span class="ph-prvalue">12NC/SKU</span>: <span class="ph-shoppinglistcode">' + productCode +
    '</span></div><div class="myshopping-list-ctn">' +
    sapEanElement +
    '</div><div class="myshopping-list-ctn">' + dataArr[2] + '</div></div><div class="ph-float-left ph-quote-delSec-m">' +
    '<div class="quantity ph-listquantity ph-float-left ph-ml-xl-4 ph-ml-md-2 ph-quote-deskView">' +
    '<input type="button" value="+" class="ph-quote_qtyplus ph-list_plusminus " field="' + newCount +
    'desk' + productCode + '" data-listname="aa" data-min=' + dataArr[1] + '><input type="text" id="' + newCount + 'desk' +
    productCode + '" class="ph-quantity ph-quantityDesk ph-return-qtybox-quote" maxlength="10" name="' + productCode +
    '" max="999999" min=' + dataArr[1] + ' data-qtylistname="aa" data-min=' + dataArr[1] + ' value=' + dataArr[1] + ' onkeypress="return isNumberKey(event)">' +
    '<input type="button" value="-" class=" ph-quote_qtyminus ph-list_plusminus ph-disable-button" field="' + newCount +
    'desk' + productCode + '" data-listname="aa" data-min=' + dataArr[1] +
    '></div>' + '<div class="ph-col-1 ph-m-0 ph-mt-lg-2 ph-float-left ph-float-lg-right ph-quote-deskView">' +
    '<div class="ph-img-trashbin ph-quickorder ph-quote-del" data-attr="' + productCode + '-' +
    newCount + '"></div></div>' + '</div></div>';

    /* eslint-enable no-useless-concat */
    $('.ph-quote__parent .product-container').append(addProduct);
  }
};
/* eslint-enable max-params */
ACC.autocomplete.bindAll();

$(document).on('click', '.addRow', function() {
  ACC.autocomplete.bindAll();
});

/* eslint-enable max-lines */
/* eslint-enable vars-on-top */
/* eslint-enable id-match */
/* eslint-enable max-len */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable max-statements */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable no-underscore-dangle */
/* eslint-enable radix */
